import http from '../http'

export default {
  // 阿里巴巴关键词搜索
  getProductListByKeyword(data: object) {
    return http.post('/third/alibaba/cross_border/search_product/keyword/query_by_page', data)
  },
  // 阿里巴巴货品详情
  getAlibabaProductDetail(data: object) {
    return http.post('/third/alibaba/cross_border/product_detail/query', data)
  },
  // 阿里巴巴上传图片
  thirdImageUpload(data: object) {
    return http.post('/third/alibaba/cross_border/image_upload', data)
  },
  // 阿里巴巴图片搜索
  getProductListByImage(data: object) {
    return http.post('/third/alibaba/cross_border/search_product/image/query_by_page', data)
  },
}
